import { inject, Injectable } from '@angular/core'

import { Observable } from 'rxjs'

import { PricingPlans } from '@ti/contracts'
import { ApiService } from '@ti/core/api'
import { Memoize } from '@ti/core/common/decorators'
import { LanguageService } from '@ti/core/ui-kit/i18n'

@Injectable()
export class PricingPlansProvider {
  protected readonly api = inject(ApiService)
  protected readonly languageService = inject(LanguageService)

  @Memoize()
  get pricingPlansLabels$(): Observable<Record<PricingPlans, string>> {
    const roleList = Object.values(PricingPlans)
    const labelsMap: Record<number, string> = {}
    roleList.forEach((planId) => {
      labelsMap[planId as number] = `tsp-admin.fleets.pricing-plans.${planId}`
    })
    return this.languageService.massTranslate$(labelsMap)
  }
}
